import { MenuItem, Select, Skeleton, TextField, Theme, useTheme } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { SubscribersAdmin } from '../../../../hooks/useSubscribers';

const crossReferenceSubscriberIdStorageKey = (subscriberId: string) => `sextforceMetricsCrossReferenceSubscriberId_${subscriberId}`;

type Props = {
    subscribers: any[] | SubscribersAdmin | undefined;
    subscribersLoading: boolean;
    crossReferenceSubscriberId: string;
    setCrossReferenceSubscriberId: (value: string) => void;
};

const SextforceMetricsCrossReferenceEarningsSubscriberSelector = (props: Props) => {
    const { subscribers, subscribersLoading, crossReferenceSubscriberId, setCrossReferenceSubscriberId } = props;
    const theme: Theme = useTheme();
    const params = useParams();
    const recalledFromStorage = useRef<boolean>(false);

    useEffect(() => {
        if (recalledFromStorage.current || !params.userId) {
            return;
        }

        recalledFromStorage.current = true;

        const stored = localStorage.getItem(crossReferenceSubscriberIdStorageKey(params.userId));

        // Only recall the stored value if no selection has been made yet so that a value
        // controlled by the parent (e.g. a settings dialog draft) is not overridden
        if (stored !== null && crossReferenceSubscriberId === 'none') {
            setCrossReferenceSubscriberId(stored);
        }
    }, [params.userId, crossReferenceSubscriberId, setCrossReferenceSubscriberId]);

    const updateCrossReferenceSubscriberId = (id: string) => {
        setCrossReferenceSubscriberId(id);

        if (params.userId) {
            localStorage.setItem(crossReferenceSubscriberIdStorageKey(params.userId), id);
        }
    };

    return subscribersLoading ? (
        <Skeleton />
    ) : (
        <>
            {subscribers && Array.isArray(subscribers) ? (
                <Select
                    fullWidth
                    value={crossReferenceSubscriberId}
                    onChange={e => updateCrossReferenceSubscriberId(e.target.value)}
                    size="small"
                    sx={{
                        marginTop: '4px',
                    }}
                >
                    <MenuItem value="none">
                        <span style={{ color: theme.palette.grey[800] }}>
                            <em>none</em>
                        </span>
                    </MenuItem>
                    <MenuItem value="all">All Accounts</MenuItem>
                    <MenuItem value={undefined} disabled>
                        ----------
                    </MenuItem>
                    {subscribers
                        .filter(subscriber => subscriber._id !== params.userId)
                        .splice(0)
                        .sort((a, b) => a.username.localeCompare(b.username))
                        .map((subscriber: any) => (
                            <MenuItem key={subscriber._id} value={subscriber._id}>
                                {subscriber.username}
                            </MenuItem>
                        ))}
                </Select>
            ) : (
                <TextField
                    fullWidth
                    label="Cross-Pollination Account"
                    size="small"
                    placeholder="Enter a subscriber ID to cross-reference with"
                    value={crossReferenceSubscriberId === 'none' ? '' : crossReferenceSubscriberId}
                    onChange={e => {
                        // delay the search by 1 second
                        // setTimeout(() => {
                        updateCrossReferenceSubscriberId(e.target.value);
                        // }, 1000);
                    }}
                />
            )}
        </>
    );
};

export default SextforceMetricsCrossReferenceEarningsSubscriberSelector;
